import {createStrokeSVG} from './TEMPLATE'

// tabler: users-minus
export const PeopleRemove2_Stroke1_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M5 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0',
    'M3 21v-2a4 4 0 0 1 4 -4h4c.948 0 1.818 .33 2.504 .88',
    'M16 3.13a4 4 0 0 1 0 7.75',
    'M16 19h6',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 1.5,
})

// tabler: users-minus
export const PeopleRemove2_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M5 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0',
    'M3 21v-2a4 4 0 0 1 4 -4h4c.948 0 1.818 .33 2.504 .88',
    'M16 3.13a4 4 0 0 1 0 7.75',
    'M16 19h6',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
